import React, { useCallback, useEffect } from 'react';

import { toUSD } from 'helpers/NumberFormats';
import useMartyContext from 'hooks/useMartyContext';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';

import css from 'styles/components/search/sponsoredProducts.scss';

const SponsoredProducts = ({
  onHeartClick,
  showHearting,
  hearts,
  msaImageParams,
  showRatingStars,
  heartsList,
  heartsData,
  sponsoredProducts,
  searchTerm,
  trackSponsoredProductEvent
}) => {
  const { testId } = useMartyContext();
  const additionalMelodyCardProductClasses = { container: css.firstRow };

  const handleSponsoredProductClick = useCallback(({ index, styleId, adId }) => () => {
    trackSponsoredProductEvent({ eventType: 'click', styleId, adId, searchTerm, index });
  }, [searchTerm, trackSponsoredProductEvent]);

  useEffect(() => {
    trackSponsoredProductEvent({ eventType: 'view', searchTerm });
  }, [searchTerm, trackSponsoredProductEvent]);

  const makeProducts = () => sponsoredProducts.styles.map((product, index) => {
    // Massage data for price formatting
    const cardData = {
      ...product,
      price: toUSD(product.price),
      originalPrice: toUSD(product.originalPrice),
      isSponsored: true
    };
    return (
      <MelodyCardProduct
        key={product.styleId}
        onComponentClick={handleSponsoredProductClick({ index, styleId: product.styleId, adId: sponsoredProducts.adId })}
        componentStyle="searchProductInlineRecos"
        heartsData={heartsData}
        showFavoriteHeart={showHearting}
        onHeartClick={onHeartClick}
        hearts={hearts}
        additionalClasses={additionalMelodyCardProductClasses}
        cardData={cardData}
        msaImageParams={msaImageParams}
        melodyCardTestId={testId('searchResultsSponsoredProducts')}
        showRatingStars={showRatingStars}
        heartsList={heartsList}
      />
    );
  });

  return (
    <>
      {makeProducts()}
    </>
  );
};

export default SponsoredProducts;
